// extracted by mini-css-extract-plugin
export default {"form-delete":"delete-transaction-form_form-delete__UuJBz","row":"delete-transaction-form_row__SkB1k"};